module.exports = __webpack_public_path__ + "static/media/tariffs_white-01.6eb42f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/tariffs_white-01.png
// module id = 7698
// module chunks = 0